import i18n from "@/common/i18n";
import Layout from '@/layout/embedLayout';
const router = [{
  path: '/embed/material',
  component: Layout,
  meta: {
    auth: true,
    title: i18n.t("lang.k_008001"),
    name: 'Material'
  },
  hide: true,
  children: [{
    path: 'video',
    component: () => import('@/views/MaterialModule/video'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_008002"),
      name: 'videoMgr'
    }
  }]
}, {
  path: '/embed/media/preview',
  meta: {
    auth: true,
    title: i18n.t("lang.k_008003"),
    name: 'Material'
  },
  hide: true,
  component: () => import('@/views/MaterialModule/MediaPreview.vue')
}];
export default router;